/**
 * Pages that render their own breadcrumb inside <main>: a trail that names the
 * page, with linked parents, and its BreadcrumbList. The layout's
 * AutoBreadcrumbs renders nothing on them. Before 2026-10-11 it stacked a second
 * trail above, built from the slug ("Home › Kaal sarp dosha" over "Home › Kaal
 * Sarp Dosh › 12 Types of Kaal Sarp Dosh"), on 110 of these sitemap pages.
 * The festival directories and /shubh-muhurat/ went the other way: their own
 * trails went, and the layout's is their only one.
 *
 * The skip reads only the path, so a listed route must render its trail for
 * every query (tests/page-owned-breadcrumbs.test.ts fails on one that reads
 * searchParams, on a template with its own trail that this list misses, and on
 * a listed route without one).
 *
 * AutoBreadcrumbs only. The shared resolver (src/lib/breadcrumbs-base.ts), which
 * skips the festival detail pages the same way (FESTIVAL_DETAIL_PATH), also
 * builds the content Worker's breadcrumb and BreadcrumbList for the D1 pages
 * (edge-db/worker/breadcrumb-trail.ts), so a skip there would re-render the
 * live /rashi/<sign>/ and Hindi antardasha pages before their switch.
 * ChromeModeBoundary (src/app/_layout-chrome-gate.tsx) keys <main> on this too.
 */
const PAGE_OWNED_BREADCRUMB_PATHS: readonly RegExp[] = [
  /^\/blog\/(?:[a-z0-9-]+\/)?$/,
  /^\/nakshatra\/[a-z0-9-]+\/$/,
  /^\/reports\/[a-z0-9-]+\/$/,
  /^\/yearly-rashifal\/(?:[a-z0-9-]+\/)?$/,
  /^\/(?:graha|yoga)\/$/,
  /^\/gemstones\/[a-z0-9-]+\/$/,
  /^\/lal-kitab-remedies\/[a-z0-9-]+\/$/,
  /^\/mantras\/[a-z0-9-]+\/$/,
  /^\/vastu-shastra\/[a-z0-9-]+\/$/,
  /^\/(?:kaal-sarp-dosha|mangal-dosha-calculator|pitra-dosha|sade-sati)\/(?:marriage|phases|puja-cost|symptoms|types|upay)\/$/,
  // Content Worker pages until their D1 switch (src/data/d1-handoff-pending.json).
  /^\/rashi\/[a-z]+\/$/,
  /^\/hi\/mahadasha\/[a-z]+\/[a-z]+-antardasha\/$/,
];

/** Whether the page at `pathname` renders its own breadcrumb. */
export function rendersOwnBreadcrumb(pathname: string): boolean {
  const path = pathname.endsWith("/") ? pathname : `${pathname}/`;
  return PAGE_OWNED_BREADCRUMB_PATHS.some((pattern) => pattern.test(path));
}
